import { translate } from '@utils/i18n';
const namespace = 'features.ai_to_review_inspections.index.columns';
export const CACHE_KEY = 'ai-to-review-inspections-index';
export const ALL_COLUMNS = [
    'inspectionId',
    'building',
    'frequency',
    'risk',
    'compliance',
    'inspectionDate',
    'assignedTo',
    'totalIssues',
    'resolved',
    'unresolved',
    'iimReviewStatus',
    'inspectionStatus',
    'actions'
];
export const getColumnsConfig = (InspectionIdCell, BuildingCell, ActionsCell, InspectionStatusCell, RiskCell, ComplianceCell) => ({
    selected: {
        id: 'selected',
        field: 'selected',
        title: '',
        sortable: false,
        width: '64px',
        className: 'k-table-td --selector',
        headerClassName: 'k-table-th --selector'
    },
    inspectionId: {
        id: 'inspectionId',
        field: 'id',
        title: translate('inspection_id', { namespace }),
        sortable: true,
        width: '120px',
        className: 'k-table-td --primary',
        headerClassName: 'k-table-th --primary',
        cell: InspectionIdCell
    },
    building: {
        id: 'building',
        field: 'building',
        title: translate('building', { namespace }),
        sortable: true,
        width: '200px',
        cell: BuildingCell
    },
    frequency: {
        id: 'frequency',
        field: 'frequency',
        title: translate('frequency', { namespace }),
        sortable: true,
        width: '120px'
    },
    // IP-14530: IPA peer-job risk rating badge (read-only triage signal).
    risk: {
        id: 'risk',
        field: 'riskRating',
        title: translate('risk', { namespace }),
        sortable: false,
        width: '150px',
        cell: RiskCell
    },
    // IP-14532: deterministic frequency-compliance badge (read-only).
    compliance: {
        id: 'compliance',
        field: 'complianceStatus',
        title: translate('compliance', { namespace }),
        sortable: false,
        width: '160px',
        cell: ComplianceCell
    },
    inspectionDate: {
        id: 'inspectionDate',
        field: 'inspectionDate',
        title: translate('inspection_date', { namespace }),
        sortable: true,
        width: '140px'
    },
    assignedTo: {
        id: 'assignedTo',
        field: 'assignedTo',
        title: translate('assigned_to', { namespace }),
        sortable: true,
        width: '150px'
    },
    totalIssues: {
        id: 'totalIssues',
        field: 'totalIssues',
        title: translate('total_issues', { namespace }),
        sortable: true,
        width: '120px'
    },
    resolved: {
        id: 'resolved',
        field: 'resolved',
        title: translate('resolved', { namespace }),
        sortable: true,
        width: '100px'
    },
    unresolved: {
        id: 'unresolved',
        field: 'unresolved',
        title: translate('unresolved', { namespace }),
        sortable: true,
        width: '120px'
    },
    iimReviewStatus: {
        id: 'iimReviewStatus',
        field: 'iimReviewStatus',
        title: translate('iim_review_status', { namespace }),
        sortable: true,
        width: '250px'
    },
    inspectionStatus: {
        id: 'inspectionStatus',
        field: 'inspectionStatus',
        title: translate('inspection_status', { namespace }),
        sortable: false,
        width: '160px',
        cell: InspectionStatusCell
    },
    actions: {
        id: 'actions',
        field: 'actions',
        title: translate('actions', { namespace }),
        sortable: false,
        width: '100px',
        cell: ActionsCell
    }
});
